import type { IconAsset } from '../Icon.types';

export const chevronDown: IconAsset = {
  bold: {
    l: {
      code: (
        <path
          clipRule='evenodd'
          d='M12 17.6967L20.5754 9.12132L18.454 7L12 13.454L5.54595 7L3.42463 9.12132L12 17.6967Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    m: {
      code: (
        <path
          clipRule='evenodd'
          d='M10 14.0606L17.0607 6.99998L14.9393 4.87866L10 9.818L5.06066 4.87866L2.93934 6.99998L10 14.0606Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    s: {
      code: (
        <g
          fill='none'
          transform='translate(8.000000, 8.000000) rotate(90.000000) translate(-8.000000, -8.000000)'
        >
          <polygon points='0 0 16 0 16 16 0 16' />
          <polygon
            fill='currentColor'
            points='6.41 2 5 3.41 9.58 8 5 12.59 6.41 14 12.41 8'
          />
        </g>
      ),
    },
  },
  regular: {
    l: {
      code: (
        <path
          clipRule='evenodd'
          d='M12 16.4644L20.2218 8.24263L18.8076 6.82842L12 13.636L5.1924 6.82842L3.77818 8.24263L12 16.4644Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    m: {
      code: (
        <path
          clipRule='evenodd'
          d='M10 13.7071L16.7071 7L15.2929 5.58578L10 10.8787L4.70711 5.58578L3.29289 7L10 13.7071Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    s: {
      code: (
        <path
          clipRule='evenodd'
          d='M8 10.7071L12.7071 6L11.2929 4.58578L8 7.87868L4.70711 4.58578L3.29289 6L8 10.7071Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
  },
};
